module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "button is-primary is-pulled-right",
    attrs: {
      "to": {
        name: 'discount-create'
      }
    }
  }, [_vm._v("\n        Add discount\n    ")]), _vm._v(" "), _c('data-table', {
    attrs: {
      "data-set": _vm.discounts,
      "page-length": 50,
      "columns": [{
          name: 'Code',
          type: 'text',
          prop: 'code'
        },
        {
          name: 'Name',
          type: 'text',
          prop: 'name'
        },
        {
          name: 'Updated',
          type: 'date',
          prop: 'updated_at',
          filter: ['moment', ['from', 'now']]
        },
        {
          name: 'Created',
          type: 'date',
          prop: 'created_at',
          filter: ['moment', ['from', 'now']]
        } ]
    },
    scopedSlots: _vm._u([{
      key: "column_Code",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'discount',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v("\n                " + _vm._s(props.row.code) + "\n            ")])]
      }
    }, {
      key: "column_Name",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'discount',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v("\n                " + _vm._s(props.row.name) + "\n            ")])]
      }
    }, {
      key: "controls",
      fn: function(props) {
        return [_c('td', [_c('div', {
          staticClass: "has-text-right"
        }, [(props.row.enabled) ? _c('a', {
          on: {
            "click": function($event) {
              return _vm.disableDiscount(props.row)
            }
          }
        }, [_vm._v("\n                        Enabled "), _c('span', {
          staticClass: "icon"
        }, [_c('i', {
          staticClass: "fa fa-toggle-on"
        })])]) : _c('a', {
          on: {
            "click": function($event) {
              return _vm.enableDiscount(props.row)
            }
          }
        }, [_vm._v("\n                        Disabled "), _c('span', {
          staticClass: "icon"
        }, [_c('i', {
          staticClass: "fa fa-toggle-off"
        })])]), _vm._v("\n                     \n                    "), _c('a', {
          staticClass: "delete",
          on: {
            "click": function($event) {
              return _vm.deleteDiscount(props.row)
            }
          }
        })])])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bb4f0b5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/discounts/DiscountList.vue
// module id = 549
// module chunks = 0